import React from 'react';

import { Box, Container, Grid }from '@material-ui/core/';
// core components

import Button from '../../components/CustomButtons/Button';
import Card from '../../components/Card/Card';
import CardBody from '../../components/Card/CardBody';
import CustomInput from '../../components/CustomInput/CustomInput';

import { Wrapper, Logo } from './styled/';

import logo from '../../assets/img/prognostic.png';
import GridItem from '../../components/Grid/GridItem';
import { Link } from 'react-router-dom';

class Login extends React.Component{

  render() {
    return (
      <Wrapper>
        <Container maxWidth="sm">
          <Grid container justify="center">
            <Grid item xs={12} sm={12} md={8} lg={8}>
              <Grid container justify="center">
                <Box paddingTop="15%">
                  <Logo alt="logo" width="200" src={logo}/>
                  <Card>
                    <CardBody>
                      <GridItem xs={12}>
                          <CustomInput
                            labelText="Username"
                            id="username"
                            formControlProps={{
                              fullWidth: true
                            }}
                          />
                          <CustomInput
                            labelText="Password"
                            id="password"
                            formControlProps={{
                              fullWidth: true
                            }}
                          />
                      </GridItem>
                      <Link to="/admin/dashboard">
                        <Button color="primary" type="submit">Login</Button>
                      </Link>
                    </CardBody>
                  </Card>
                </Box>  
             </Grid>
            </Grid>
          </Grid>
        </Container>
      </Wrapper>
    );
  }
}

export default (Login);
